import styles from "@css/modules/pointsGuide.module.scss"
import compStyles from "@css/Components.module.scss"
import React, { useEffect, useRef, useState } from "react"
import cn from "classnames"
import { PointsSummary } from "@components/Listings/PointsSummary"
import { ResortsCarousel } from "./ResortsCarousel"
import { ArrowLeftThin } from "@css/icons/SVG"
import Nouislider from "nouislider-react"
import "nouislider/dist/nouislider.css"

const startAt = 50
const multiply = 25
const pointsList = new Array((2000 - startAt) / multiply).fill(0).map((_, index) => {
    const current = index * multiply
    return {
        min: startAt + current,
        max: startAt + current + multiply - 1
    }
})

const tooltip = [
    {
        to: (val) => {
            val = Math.round(val)
            return `${val} - ${val + multiply - 1}`
        }
    }
]

function between(min, max, val) {
    return val >= min && val <= max
}

export function Step6({ resorts, data, mobile }) {
    const [pointIndex, setPointIndex] = useState(() => {
        const index = data["6"] < startAt ? 0 : pointsList.findIndex((i) => between(i.min, i.max, data["6"]))
        return index > -1 ? index : pointsList.length - 1
    })
    const [points, setPoints] = useState(() => data["6"])
    const [resort, setResort] = useState(() => {
        const { resort, hiddenResort } = data["4"]
        return resort || hiddenResort
    })
    useEffect(() => {
        document.getElementById("point-index-" + pointIndex)?.scrollIntoView({
            behavior: "auto",
            inline: "center",
            block: "nearest"
        })
    }, [])
    const onPointsClick = (event) => {
        const index = +event.target.dataset.index
        setPointIndex(index)
        setPoints(pointsList[index].max)
        event.target?.scrollIntoView({
            behavior: "auto",
            inline: "center",
            block: "nearest"
        })
    }
    const ref = useRef(null)
    const scrollRoot = (right) => {
        if (ref.current) {
            const width = ref.current.parentElement.offsetWidth / 2
            ref.current.scrollBy(right ? width : -width, 0)
        }
    }
    const onChange = (tooltip, nup, [val1]) => {
        const val = Math.round(val1)
        const index = pointsList.findIndex((i) => i.min === val)
        setPointIndex(index)
        setPoints(pointsList[index].max)
    }
    return (
        <div className={styles.stepContainer}>
            <div className={cn(styles.stepContent, styles.step6Content)}>
                <h2>How far will your points go?</h2>
                {mobile ? (
                    <div className={cn(styles.sliderWrapper, compStyles.sliderWrapper)}>
                        <Nouislider
                            onChange={onChange}
                            start={[pointsList[pointIndex].min]}
                            tooltips={tooltip}
                            behaviour={"tap-drag"}
                            range={{
                                min: startAt,
                                max: 1975
                            }}
                            step={multiply}
                        />
                    </div>
                ) : (
                    <div className={compStyles.pointsListContainer}>
                        <button className={styles.arrow} onClick={() => scrollRoot()}>
                            <ArrowLeftThin />
                        </button>
                        <button className={styles.arrow} onClick={() => scrollRoot(true)}>
                            <ArrowLeftThin />
                        </button>
                        <ul ref={ref} className={compStyles.pointsList}>
                            {pointsList.map((i, index) => {
                                return (
                                    <li
                                        key={index}
                                        id={"point-index-" + index}
                                        className={cn({
                                            [compStyles.pointItem]: true,
                                            [compStyles.pointItemActive]: index === pointIndex
                                        })}
                                        data-index={index}
                                        onClick={onPointsClick}>
                                        {i.min}-{i.max}
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                )}

                <div className={styles.bottomContentWrap}>
                    <div className={styles.overSummery}>
                        <PointsSummary
                            classes={{
                                root: styles.pointSummaryRoot
                            }}
                            title="Avg length of stay"
                            resort={resort}
                            points={points}
                            resorts={resorts}
                        />
                    </div>
                    <div className={styles.overCarousel}>
                        <ResortsCarousel resort={resort} setResort={setResort} resorts={resorts} />
                    </div>
                </div>
            </div>
        </div>
    )
}
